import { api } from 'app/api';


class ConfirmationService {
  async getPtcfmt(params) {
    // CORS 대응이후 url 환경변수 사용으로 변경
    // return axios.get('mock/ptcfmt.json');
    return api.get(`/dfd/api/if/web/ptcfmt`, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      params: params,
    });
  }

  async postPtcfmtcmpl(param) {
    // CORS 대응이후 url 환경변수 사용으로 변경
    // return axios.get('mock/ptcfmtcmpl.json');
    return api.post(`/dfd/api/if/web/ptcfmtcmpl`, param, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  }

  async postCommonPtcfmtcmpl(param) {
    // CORS 대응이후 url 환경변수 사용으로 변경
    return api.post(`/dfd/api/if/web/front/common/process`, param, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  }

  async postConfirmation({ usrId, hspId, hspCd, ptNm, ptRrn, moduleType }) {
    // return axios.get('mock/rlnmcfmt.json');
    return api.post(
      `/dfd/api/if/web/rlnmcfmt`,
      { usrId, hspId, hspCd, ptNm, ptRrn, moduleType },
      {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      },
    );
  }
  async postCommonConfirmation({ usrId, hspId, hspCd, ptNm, ptRrn, moduleType }) {
    return api.post(
      `/dfd/api/if/web/front/certification/common/process`,
      { usrId, hspId, hspCd, ptNm, ptRrn, moduleType },
      {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      },
    );
  }
}
export default new ConfirmationService();
